import { Anexos } from "./Anexos";

export default Anexos;